var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Share"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 302"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 569",
    x: 3.75,
    y: 3.75,
    width: 17.5,
    height: 17.5,
    rx: 1.25,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 1",
    x1: 9.75,
    y1: 3,
    x2: 9.75,
    y2: 22,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 2",
    x1: 15.75,
    y1: 3,
    x2: 15.75,
    y2: 22,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 3",
    x1: 21.002,
    y1: 9.75,
    x2: 3.00195,
    y2: 9.75,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 4",
    x1: 21.002,
    y1: 15.375,
    x2: 3.00195,
    y2: 15.375,
    stroke: "white",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.23c25e95fa5c03cb962658a70a25033d.svg";
export { ForwardRef as ReactComponent };